<template>
  <div>
    <div v-show="showGallery" class="gallery">
      <div class="cover"></div>
      <template v-if="presentationImg.length > 0">
        <vue-draggable 
          v-model="presentationImg" 
          class="img-list"
          force-fallback="true"
          handle=".img--content-wrap"
          :class="{
            'img-list__dense': presentationImg.length > 4,
          }"
        >
          <div 
            v-for="(item, index) in presentationImg" 
            :key="item.url" 
            class="img-wrap"
            :style="{
              'width': imgRect.width,
              'height': imgRect.height,
            }"
            @click="enableFullscreen($event, index)"
          >
            <div class="img--content-wrap">
              <img
                :src="item.url"
                class="img--content" alt="">
            </div>
            <div class="img--tools">
              <div class="img--tool ignore-elements" @click.stop="removeImage($event, index)">
                <img src="~@/assets/images/throwingPic/remove_ico.svg" class="img--tool-icon" alt="">
                <div class="img--tool-text">移除</div>
              </div>
              <div class="img--tool ignore-elements" @click.stop="enableFullscreen($event, index)">
                <img src="~@/assets/images/throwingPic/full_screen.svg" class="img--tool-icon" alt="">
                <div class="img--tool-text">全屏</div>
              </div>
            </div>
          </div>
        </vue-draggable>
      </template>
      <div v-else class="img-list">
        <div 
          class="img-wrap empty"
          :style="{
            'width': imgRect.width,
            'height': imgRect.height,
          }"
        >
          <div class="img--content-wrap">
            <img
              src="~@/assets/images/empty_tip_img.svg"
              class="img--content" alt="">
          </div>
        </div>
      </div>
      <div class="controls">
        <div class="controls__btn" @click="minimizeWindow">
          <img src="~@/assets/images/throwingPic/minimize_ico.svg" class="controls__btn-img" alt="">
          <div class="controls__btn-text">最小化</div>
        </div>
        <div class="controls__btn" @click="close">
          <img src="~@/assets/images/throwingPic/close1.svg" class="controls__btn-img" alt="">
          <div class="controls__btn-text">关闭</div>
        </div>
      </div>
    </div>
    <detail-view 
      v-if="showDetailView" 
      :img-list="presentationImg"
      :current-index="selectedIndex"
      @close="toggleGallery(true)"
    ></detail-view>
    <MiniWindow 
      v-if="isShowMiniWin"
      :imgList="presentationImg"
      @close="close"
      @expand="expand"
    ></MiniWindow>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import DetailView from './DetailView';
import MiniWindow from './part/MiniWindow';

export default {
  props: [ 'imgList' ],
  components: {
    DetailView,
    VueDraggable: draggable,
    MiniWindow,
  },
  data() {
    return {
      showGallery: true,
      showDetailView: false,
      selectedIndex: -1,
      imgRect: {
        width: null,
        height: null,
      },
      isShowMiniWin: false,
    };
  },
  computed: {
    presentationImg: {
      get() {
        return this.imgList;
      },
      set(imgList) {
        this.updatePicList(imgList);
      },
    }
  },
  watch: {
    presentationImg: {
      handler() {
        this.calcImgRect();
      },
      immediate: true,
    }
  },
  methods: {
    minimizeWindow() {
      this.isShowMiniWin = true;
      this.showGallery = false;
    },

    close() {
      this.$emit('close');
    },

    expand() {
      this.showGallery = true;
      this.isShowMiniWin = false;
    },
    
    removeImage(e, index) {
      const imgList = this.presentationImg.filter((img, i) => i !== index);
      this.updatePicList(imgList);
    },

    enableFullscreen(e, index) {
      // e.stopPropagation();
      this.selectedIndex = index;
      this.toggleGallery(false);
    },

    toggleGallery(val) {
      this.showGallery = val;
      this.showDetailView = !val;
    },

    updatePicList(imgList) {
      this.$emit('change', imgList);
    },

    calcImgRect() {
      let width = '25%';
      let height = '50%';

      if (this.presentationImg.length <= 4) {
        const maxBounds = {
          width: window.innerWidth - 25 * 2,
          height: window.innerHeight - 64,
        };

        width = maxBounds.width / 4;
        height = width * 80 / 46;

        if (height > maxBounds.height) {
          height = maxBounds.height;
          width = height * 46 / 80;
        }

        width = Math.round(width) + 'px';
        height = Math.round(height) + 'px';
      }

      this.imgRect.width = width;
      this.imgRect.height = height;
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.cover {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .8);
}

.controls {
  position: absolute;
  bottom: 0;
  left: 50%;
  display: flex;
  border-radius: 10px 10px 0px 0px;
  background-color: rgba(255, 255, 255, .94);
  transform: translateX(-50%);
}

.controls__btn {
  width: 85px;
  height: 64px;
  padding-top: 8px;
  padding-bottom: 6px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.controls__btn::after {
  content: '';
  position: absolute;
  top: 8px;
  bottom: 6px;
  right: 0;
  width: 1px;
  background-color: #DADEE6;
}

.controls__btn:last-child::after {
  display: none;
}

.controls__btn-img {
  display: block;
  width: 30px;
  height: 30px;
}

.controls__btn-text {
  font-size: 12px;
  color: #586D94;
  font-weight: 500;
  margin-top: 5px;
}

.img-list {
  position: absolute;
  width: 100%;
  top: calc((100% - 64px) / 2);
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-list.img-list__dense {
  flex-wrap: wrap;
  top: 0;
  bottom: 64px;
  transform: initial;
  justify-content: initial;
}

.img-wrap {
  position: relative;
  width: 460px;
  height: 800px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);
  cursor: pointer;

  &.empty {
    cursor: initial;

    .img--content-wrap {
      width: 80%;
      margin: auto;
      flex-direction: column;
      align-items: center;
    }
  }
}

.img-list__dense .img-wrap {
  width: 25%;
  height: 50%;
}

.img--content-wrap {
  padding: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
}

.img--content {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.img--tools {
  position: absolute;
  z-index: 1;
  left: 20px;
  right: 20px;
  bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.img--tool {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px 6px 8px;
  border-radius: 14px;
  background-color: rgba(34, 34, 34, .49);
  cursor: pointer;
}

.img--tool-icon {
  display: block;
  width: 16px;
  height: 16px;
  margin-right: 6px;
}

.img--tool-text {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
  flex-shrink: 0;
}

.sortable-ghost {
  opacity: 1;
}

.sortable-ghost .img--content-wrap,
.sortable-ghost .img--tools {
  opacity: 0;
}

.sortable-drag {
  z-index: 2;
  opacity: 1;
  background-color: rgb(180, 216, 254);
}

.sortable-drag::after {
  content: '';
  position: absolute;
  top: -1px;
  right: -1px;
  bottom: -1px;
  left: -1px;
  border: 2px solid #037BFE;
}
</style>